import React from "react";
import { EditRuleInputPropType } from "../../Pages/DefineModel/model";

const RuleInputComponent = ({
  ruleState,
  onChangeHandler,
  onSaveHandler,
  value,
  setInputRef,
}: EditRuleInputPropType) => {
  return (
    <div className="tw-rounded tw-bg-shades-of-grey-10 tw-box-border tw-w-[100%] tw-h-10 tw-flex tw-flex-row tw-items-center tw-justify-start tw-mt-1 tw-px-0.5 m-2 tw-gap-[2px] tw-text-sm tw-text-shades-of-grey-60 tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 focus:tw-outline-none">
      <input
        className="tw-h-8 tw-w-[95%] tw-bg-shades-of-grey-10 tw-pl-0"
        value={ruleState ?? value?.ruleExp}
        onChange={onChangeHandler}
        ref={(el) => setInputRef(el)}
      />
      <button
        className="tw-rounded tw-bg-primary tw-text-white  tw-flex tw-flex-row tw-items-center tw-justify-center tw-h-7 tw-w-[10%] tw-py-1 tw-px-2.5 tw-gap-[4px] tw-text-sm  tw-border-[1px] tw-border-solid tw-border-primary"
        onClick={(e) => onSaveHandler(e, value ? "Edit" : "save")}
      >
        Done
      </button>
    </div>
  );
};

export default RuleInputComponent;
